import { tokenAliasOrValue } from "./base";
import { z } from "zod";
export const TextCase = z.enum([
    "Original",
    "Upper",
    "Lower",
    "Camel",
    "SmallCaps",
]);
export const TextCaseValue = TextCase;
export const TextCaseTokenData = tokenAliasOrValue(TextCaseValue);
